"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = refresh;
const cache = {};
const optsDefault = {
  url: "https://static-data.kiwi.com/",
  ttl: 60 * 1000,
  // one minute
  headers: {}
};
async function refresh(file, {
  url = optsDefault.url,
  ttl = optsDefault.ttl,
  headers = optsDefault.headers
} = optsDefault) {
  if (file in cache) {
    const entry = cache[file];
    if (Date.now() - ttl <= entry.createdAt) {
      return entry.data;
    }
  }
  const data = await fetch(url + file, {
    headers: {
      Accept: "application/json",
      ...headers
    }
  }).then(res => {
    if (!res.ok) {
      return Promise.reject(new Error(`[Nitro] failed to fetch: ${url + file}`));
    }
    return res.json();
  });

  /* eslint-disable require-atomic-updates */
  // Race conditions are okay-ish here, worst case a couple MS older data
  cache[file] = {
    data,
    createdAt: Date.now()
  };
  /* eslint-enable require-atomic-updates */

  return data;
}